var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssigntask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-whb-c197": "",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "ng-star-inserted",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "_ngcontent-whb-c197": "",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    "_ngcontent-whb-c197": "",
    cx: 18,
    cy: 18,
    r: 17.5,
    strokeDasharray: 3,
    className: "cu-stroke",
    stroke: "#979797",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-whb-c197": "",
    d: "M10.35,25.65 C10.35,20.9555796 13.7836186,17.15 18,17.15 C22.2249783,17.15 25.65,20.9651318 25.65,               25.65",
    strokeLinecap: "round",
    className: "cu-stroke",
    stroke: "#979797",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    "_ngcontent-whb-c197": "",
    cx: 18,
    cy: 12.9,
    r: 4.3,
    className: "cu-stroke",
    stroke: "#979797",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    "_ngcontent-whb-c197": "",
    fillRule: "nonzero",
    cx: 27.4,
    cy: 27.4,
    r: 7.7,
    className: "cu-fill",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-whb-c197": "",
    d: "M28.2,26.5 L28.2,23.946088 C28.2,23.4873147 27.819442,23.1 27.35,23.1 C26.8772851,23.1 26.5,               23.4788065 26.5,23.946088 L26.5,26.5 L23.946088,26.5 C23.4873147,26.5 23.1,26.880558 23.1,27.35 C23.1,               27.8227149 23.4788065,28.2 23.946088,28.2 L26.5,28.2 L26.5,30.753912 C26.5,31.2126853 26.880558,31.6 27.35,               31.6 C27.8227149,31.6 28.2,31.2211935 28.2,30.753912 L28.2,28.2 L30.753912,28.2 C31.2126853,28.2 31.6,               27.819442 31.6,27.35 C31.6,26.8772851 31.2211935,26.5 30.753912,26.5 L28.2,26.5 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigntask);
export default __webpack_public_path__ + "static/media/assigntask.e947059c0f52401b1e4aafde3a7ee1b6.svg";
export { ForwardRef as ReactComponent };